import { render, staticRenderFns } from "./SmsPromoter.vue?vue&type=template&id=d0163d94&scoped=true&"
import script from "./SmsPromoter.vue?vue&type=script&lang=ts&"
export * from "./SmsPromoter.vue?vue&type=script&lang=ts&"
import style0 from "./SmsPromoter.vue?vue&type=style&index=0&id=d0163d94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0163d94",
  null
  
)

export default component.exports